<section #productionSchedulePlanWrapper class="production-schedule-plan-wrapper flex-column full-height" [class.resizing]="isResizing">
  <section *ngIf="!isProductionSchedulePhaseVerify()" class="production-schedule-builder-wrapper" [class.resizing]="isResizing">
    <ng-container>
      <div class="flex-start-start">
        <app-path-layout-component
          #pathLayout
          *ngIf="canShowDrawingLibrary()"
          class="full-width"
          [style.min-height.px]="MIN_PATH_LAYOUT_HEIGHT_IN_PX"
          [style.min-width.px]="minPathLayoutWidthInPx"
          [style.height.px]="initialPathLayoutHeightInPx"
          [style.width]="getInitialPathLayoutWidthInPx()"
          [style.max-height.px]="initialPathLayoutMaxHeightInPx"
          [productionSchedule]="productionSchedule"
          [commercialUnit]="commercialUnit"
          [productionSchedulePhase]="productionSchedulePhase"
          [productionSchedulePathsOfColoredYarnSet]="productionSchedulePathsOfColoredYarnSet"
          [listOfCustomSettings]="listOfMachineQualityCustomSettings"
          [productionOrderCustomSettings]="customSettings"
          [buggyLengthMinInPicks]="buggyLengthMinInPicks"
          [buggyLengthMaxInMM]="buggyLengthMaxInMM"
          [buggyLengthMaxInPicks]="buggyLengthMaxInPicks"
          [availableSpaceInBuggyInPicks]="availableSpaceInBuggyForBuilderInPicks"
          [availableSpaceInBuggyInCommercialUnit]="availableSpaceInBuggyForBuilderInCommercialUnit"
          [pathWidths]="pathWidths"
          [isResizing]="isResizing"
          [selectedPath]="selectedPath"
          [selectedRestPathColoredYarnSet]="selectedRestPathColoredYarnSet"
          [selectedViewMode]="selectedViewMode"
          (productionSchedulePlanChanged)="onProductionSchedulePlanChanged()"
          (selectedPathOutput)="selectedPath = $event"
          (selectedRestPathColoredYarnSetOutput)="selectedRestPathColoredYarnSet = $event"
          (productionSchedulePathsOfColoredYarnSetOutput)="productionSchedulePathsOfColoredYarnSet = $event"
          (hoverPathBarOutput)="onHoverPathBarOutput()"
        ></app-path-layout-component>

        <div *ngIf="canShowPathContent()" class="resizer resizer--horizontal" [style.min-width.px]="resizerPx" (mousedown)="onResizerMouseDown($event, resizeDirection.HORIZONTAL)"></div>

        <app-path-content-component
          *ngIf="canShowPathContent()"
          class="flex-1 full-height"
          [style.min-width.px]="minPathContentWidthInPx"
          [selectedPath]="selectedPath"
          [productionSchedule]="productionSchedule"
          [productionSchedulePathsOfColoredYarnSet]="productionSchedulePathsOfColoredYarnSet"
          [commercialUnit]="commercialUnit"
          [productionOrderCustomSettings]="customSettings"
          (selectedPathContentRowDataOutput)="selectedPathContentRowData = $event"
        ></app-path-content-component>
      </div>
      <div class="resizer" [style.min-height.px]="resizerPx" (mousedown)="onResizerMouseDown($event, resizeDirection.VERTICAL)"></div>
    </ng-container>

    <app-production-schedule-drawing-library
      #drawingLibrary
      *ngIf="canShowDrawingLibrary()"
      class="drawing-library"
      [productionSchedule]="productionSchedule"
      [productionSchedulePhase]="productionSchedulePhase"
      [productionOrderCustomSettings]="customSettings"
      [showSelectedItems]="canShowSelectedItems"
      [isPreSelection]="isProductionSchedulePhasePreselection()"
      [selectedPath]="selectedPath"
      [pathWidths]="pathWidths"
      [preselectedOrderlineIds]="preselectedOrderlineIds"
      [preselectedDesignIds]="preselectedDesignIds"
      [preselectedConfigurationIds]="preselectedConfigurationIds"
      [selectedRestPathColoredYarnSet]="selectedRestPathColoredYarnSet"
      [productionSchedulePathsOfColoredYarnSet]="productionSchedulePathsOfColoredYarnSet"
      [buggyLengthMaxInPicks]="buggyLengthMaxInPicks"
      [availableSpaceInBuggyInPicks]="availableSpaceInBuggyForBuilderInPicks"
      [availableSpaceInBuggyInCommercialUnit]="availableSpaceInBuggyForBuilderInCommercialUnit"
      [marginInDentsOfMissingDesigns]="marginInDentsOfMissingDesigns"
      [selectedPathContentRowData]="selectedPathContentRowData"
      (navigateBackOutput)="navigateBackOutput.emit()"
      (selectedPathOutput)="selectedPath = $event"
      (selectedRestPathColoredYarnSetOutput)="selectedRestPathColoredYarnSet = $event"
      (selectedViewModeOutput)="selectedViewMode = $event"
    >
    </app-production-schedule-drawing-library>
  </section>

  <section class="full-height" *ngIf="isProductionSchedulePhaseVerify()">
    <div #builderContainer class="overflow-hidden builder-container" fxFlex="1 0 {{ MIN_DRAWING_LIBRARY_WIDTH_IN_PX }}px">
      <mat-card class="no-margin full-height">
        <mat-card-header fxLayoutAlign="start center">
          <h2 class="section-title flex-column no-wrap mr-8">
            {{ 'TEXTILE_DATA.COLORED_YARN_SET.COLORED_YARN_SET' | bmsTranslate: {count: 2} }}
          </h2>
          <vdw-ellipsis-label
            class="full-width overflow-hidden"
            matTooltipPosition="above"
            text="{{ 'PRODUCTION_ORDER.WEAVE_PLAN.WEAVE_PLAN_SUMMARY.LENGTH_DIFFERENCE_TO_BUGGY' | bmsTranslate }}: {{ getUnitDimensionsForLengthDifferenceToBuggy() }} {{
              'PRODUCTION_ORDER.WEAVE_PLAN.WEAVE_PLAN_SUMMARY.REST_WIDTH' | bmsTranslate
            }}:
                {{ getRestWidthDimensions() }} {{ 'PRODUCTION_ORDER.WEAVE_PLAN.WEAVE_PLAN_SUMMARY.SURFACE' | bmsTranslate }}: {{ getSurfaceDimensions() }} {{
              'PRODUCTION_ORDER.WEAVE_PLAN.WEAVE_PLAN_SUMMARY.NON_PRODUCTION_ITEMS' | bmsTranslate
            }}: {{ getNonProductionItemsDimensions() }} {{ 'TEXTILE_DATA.MACHINE_QUALITY.PRACTICALPICKDENSITY' | bmsTranslate }}: {{ getPracticalPickDensity() }}"
            [hasContent]="true"
          >
            <span>
              <span class="b2 font-weight-regular mr-4">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.WEAVE_PLAN_SUMMARY.LENGTH_DIFFERENCE_TO_BUGGY' | bmsTranslate }}:</span>
              <span class="b2 font-weight-semibold mr-8">
                {{ getUnitDimensionsForLengthDifferenceToBuggy() }}
              </span>
            </span>
            <span>
              <span class="b2 font-weight-regular mr-4">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.WEAVE_PLAN_SUMMARY.REST_WIDTH' | bmsTranslate }}:</span>
              <span class="b2 font-weight-semibold mr-8">
                {{ getRestWidthDimensions() }}
              </span>
            </span>
            <span>
              <span class="b2 font-weight-regular mr-4">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.WEAVE_PLAN_SUMMARY.SURFACE' | bmsTranslate }}:</span>
              <span class="b2 font-weight-semibold mr-8">
                {{ getSurfaceDimensions() }}
              </span>
            </span>
            <span>
              <span class="b2 font-weight-regular mr-4">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.WEAVE_PLAN_SUMMARY.NON_PRODUCTION_ITEMS' | bmsTranslate }}:</span>
              <span class="b2 font-weight-semibold mr-8">
                {{ getNonProductionItemsDimensions() }}
              </span>
            </span>
            <span>
              <span class="b2 font-weight-regular mr-4">{{ 'TEXTILE_DATA.MACHINE_QUALITY.PRACTICALPICKDENSITY' | bmsTranslate }}:</span>
              <span class="b2 font-weight-semibold mr-8">
                {{ getPracticalPickDensity() }}
              </span>
            </span>
          </vdw-ellipsis-label>

          <div #buttonsContainer fxLayout="column" fxFlex>
            <div fxLayout="row" fxLayoutGap="16px" fxFlexAlign="end">
              <div #errorsAndWarningsContainer class="errors-and-warnings">
                <app-errors-and-warnings
                  *ngIf="canShowErrorsAndWarnings()"
                  fxLayout="column"
                  [productionSchedule]="productionSchedule"
                  [isProductionSchedulePhaseVerify]="isProductionSchedulePhaseVerify()"
                  [canShowWarningWithText]="canShowWarningWithText"
                ></app-errors-and-warnings>
              </div>

              <mat-slide-toggle #editPathsToggleContainer *ngIf="!isProductionSchedulePhaseVerify()" (change)="onEditProductionSchedulePathsInColoredYarnSetToggle($event)">
                {{ 'GENERAL.ACTIONS.EDIT_OBJECT' | bmsTranslate: {object: 'PRODUCTION_ORDER.PATH' | bmsTranslate: {count: 2} | lowercase} }}
              </mat-slide-toggle>

              <mat-form-field #viewSelectorContainer class="view-mode-field no-subscript" fxFlex="175px">
                <mat-select
                  [disabled]="productionSchedule.completingPartially"
                  [value]="selectedProductionScheduleDisplay"
                  (selectionChange)="changedSelectedProductionScheduleDisplay($event)"
                  disableOptionCentering
                >
                  <mat-option *ngIf="!productionSchedule.completingPartially" [value]="productionScheduleDisplay.OVERVIEW">
                    {{ 'GENERAL.VIEW_MODES.OVERVIEW' | bmsTranslate }}
                  </mat-option>
                  <mat-option [value]="productionScheduleDisplay.LISTVIEW">
                    {{ 'GENERAL.VIEW_MODES.LISTVIEW' | bmsTranslate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </mat-card-header>
        <mat-card-content>
          <article class="production-schedule-wrapper" [class.production-schedule-new-wrapper]="hasPermissionToNewVerifyStep()">
            <app-progress-spinner
              fxFlex
              fxLayoutAlign="center center"
              *ngIf="canShowIsWeavePlanVerifyingIcon()"
              [text]="'PRODUCTION_ORDER.WEAVE_PLAN.IS_VERIFYING' | bmsTranslate"
            ></app-progress-spinner>

            <ng-container *ngIf="!canShowListView()">
              <app-progress-spinner fxFlex fxLayoutAlign="center center" *ngIf="canShowIsWeavePlanLoadingIcon()" [text]="'GENERAL.LOADING.LOADING' | bmsTranslate"></app-progress-spinner>
              <app-progress-spinner
                fxFlex
                fxLayoutAlign="center center"
                *ngIf="canShowIsWeavePlanBuildingIcon()"
                [text]="'PRODUCTION_ORDER.WEAVE_PLAN.IS_BUILDING' | bmsTranslate"
              ></app-progress-spinner>
            </ng-container>

            <app-production-schedule-verify
              *ngIf="canShowProductionScheduleBuilder() && hasPermissionToNewVerifyStep()"
              (canZoomIn)="onCanZoomInChanges($event)"
              (canZoomOut)="onCanZoomOutChanges($event)"
              [zoomLevel]="zoomLevel"
              [selectedProductionScheduleDisplay]="selectedProductionScheduleDisplay"
              [productionSchedule]="productionSchedule"
              [commercialUnit]="commercialUnit"
              [productionSchedulePhase]="productionSchedulePhase"
              [availableSpaceInBuggyInPicks]="availableSpaceInBuggyInPicks"
              [availableSpaceInBuggyInCommercialUnit]="availableSpaceInBuggyInCommercialUnit"
              [buggyLengthMinInPicks]="buggyLengthMinInPicks"
              [buggyLengthMaxInMM]="buggyLengthMaxInMM"
              [listOfCustomSettings]="listOfMachineQualityCustomSettings"
              [productionOrderCustomSettings]="customSettings"
              [buggyLengthMinInPicks]="buggyLengthMinInPicks"
              [buggyLengthMaxInPicks]="buggyLengthMaxInPicks"
              [displayTechnicalUnit]="displayTechnicalUnit"
              (productionSchedulePlanChanged)="onProductionSchedulePlanChanged()"
            >
            </app-production-schedule-verify>

            <app-production-schedule-listview
              #productionScheduleNewListView
              fxFlex
              *ngIf="canShowListView() && hasPermissionToNewVerifyStep()"
              [allowProductionScheduleItemsToBeEdited]="canEditProductionScheduleItems()"
              [productionSchedule]="productionSchedule"
              [commercialUnit]="commercialUnit"
              [productionSchedulePhase]="productionSchedulePhase"
              [listOfCustomSettings]="listOfMachineQualityCustomSettings"
              [productionOrderCustomSettings]="customSettings"
              [buggyLengthMaxInPicks]="buggyLengthMaxInPicks"
              [displayTechnicalUnit]="displayTechnicalUnit"
              [productionScheduleItemMultiplier]="productionSchedule.getProductionScheduleItemMultiplier()"
            >
            </app-production-schedule-listview>
          </article>
        </mat-card-content>
      </mat-card>
    </div>
  </section>

  <section *ngIf="isProductionSchedulePhaseVerify() && !hasPermissionToNewVerifyStep()">
    <mat-expansion-panel [expanded]="false" class="expansion-panel-as-card" (afterExpand)="scrollIntoWeavePlanSummary()">
      <mat-expansion-panel-header collapsedHeight="64px" expandedHeight="64px">
        <mat-panel-title fxFlex="0 1 auto" fxFlexAlign="center" fxLayoutAlign="start center">
          <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
            <mat-icon class="icon-36" svgIcon="builder-summary-blue"></mat-icon>
            <h3 class="font-weight-semibold builder-summary-title">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.WEAVE_PLAN_SUMMARY.WEAVE_PLAN_SUMMARY' | bmsTranslate }}</h3>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <article class="content" fxLayout="column" fxLayoutGap="2px">
        <div fxLayout="row">
          <div fxLayout="column" fxFlex fxLayoutGap="16px">
            <h3 class="font-weight-semibold">{{ 'GENERAL.SUMMARY' | bmsTranslate }}</h3>
            <div fxLayout="row" fxLayoutGap="16px">
              <app-disabled-form-input [label]="'GENERAL.NAME' | bmsTranslate" [value]="productionSchedule.name"></app-disabled-form-input>
              <app-disabled-form-input [label]="'PRODUCTION_ORDER.WEAVE_PLAN.WEAVE_PLAN' | bmsTranslate" [value]="getProductionScheduleHeight()"></app-disabled-form-input>
              <app-disabled-form-input [label]="'MACHINE.MACHINE' | bmsTranslate: {count: 1}" [value]="productionSchedule.machine.name"></app-disabled-form-input>
              <app-disabled-form-input
                [label]="'TEXTILE_DATA.MACHINE_QUALITY.MACHINE_QUALITY' | bmsTranslate: {count: 1}"
                [value]="productionSchedule.machineQuality.technicalNameWithVersion"
              ></app-disabled-form-input>
              <app-disabled-form-input [label]="'TEXTILE_DATA.MACHINE_QUALITY.PRACTICALPICKDENSITY' | bmsTranslate" [value]="getProductionSchedulePracticalPickDensity()"></app-disabled-form-input>
              <app-disabled-form-input [label]="'TEXTILE_DATA.FINISHING.FINISHING' | bmsTranslate: {count: 1}" [value]="productionSchedule.finishing?.nameWithVersion"></app-disabled-form-input>
            </div>
          </div>
        </div>

        <div fxLayout="row">
          <app-production-schedule-builder-summary
            fxFlex
            #productionScheduleBuilderSummary
            [productionSchedule]="productionSchedule"
            [commercialUnit]="commercialUnit"
            [customSettings]="customSettings"
          >
          </app-production-schedule-builder-summary>
        </div>
      </article>
    </mat-expansion-panel>
  </section>
</section>
